import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	linkedSignal,
} from '@angular/core';
import { CoreTabsComponent, CoreTabComponent } from '@core/ui';
import { Form } from '@models/client-intake';
import { TablerIconComponent } from 'angular-tabler-icons';
import { IntakeFormRendererComponent } from '../intake-form-renderer/intake-form-renderer.component';
import { CommonModule } from '@angular/common';
import { select } from '@ngxs/store';
import { BusinessState } from 'src/app/shared/state/business';
import { AuthState } from 'src/app/shared/state/auth';
import { sortForms } from '@globalUtils/client-intake';
import { PortalEngineService } from '@domain/portal-engine';
import { MatterClients } from 'src/app/shared/state/global/matter_clients';
import { SelectedMatter } from '@state/matter/matter.selectors';

@Component({
	selector: 'app-intake-form-preview',
	templateUrl: './intake-form-preview.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		CommonModule,
		CoreTabsComponent,
		CoreTabComponent,
		TablerIconComponent,
		IntakeFormRendererComponent,
	],
	providers: [PortalEngineService],
})
export class IntakeFormPreviewComponent {
	private portalEngineService = inject(PortalEngineService);

	currentForm_ = linkedSignal<Form | null>(() => {
		const forms = this.sortedForms_();
		const firstForm = forms.at(0);
		return firstForm ?? null;
	});

	selectedTab_ = linkedSignal<string | null>(() => {
		const forms = this.sortedForms_();
		const firstForm = forms.at(0);
		return firstForm?.id ?? null;
	});

	businessName_ = select(BusinessState.businessName);
	loggedInUser_ = select(AuthState.getLoggedInUser);
	clientsWithAssociations_ = select(
		MatterClients.get_personMatterClientsWithAssociationMapped,
	);
	matter_ = select(SelectedMatter.getSelected);

	sortedForms_ = computed(() => {
		const engineGeneratedForms =
			this.portalEngineService.generatePortalEnginePreviewForms(
				this.clientsWithAssociations_(),
				this.matter_(),
			);
		if (!engineGeneratedForms?.length) return [];
		return sortForms(engineGeneratedForms);
	});

	onTabChange(formId: string) {
		const sortedForms = this.sortedForms_();
		if (!sortedForms.length) return;

		const selectedForm = sortedForms.find((form) => form.id === formId);
		if (selectedForm) {
			this.currentForm_.set(selectedForm);
			this.selectedTab_.set(formId);
		}
	}
}
